import { render, staticRenderFns } from "./CheckResultDetail.vue?vue&type=template&id=22448453&scoped=true"
import script from "./CheckResultDetail.vue?vue&type=script&lang=js"
export * from "./CheckResultDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckResultDetail.vue?vue&type=style&index=0&id=22448453&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22448453",
  null
  
)

export default component.exports